import { Avatar, Card, CardContent, CardHeader, Divider, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import NumberFormat from 'react-number-format';
import ScheduleIcon from '@mui/icons-material/Schedule';
import EventNoteIcon from '@mui/icons-material/EventNote';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import IconOneProof from 'assets/images/IconOneProof.png';
const OneProofSlipCard = ({ OneProofData }) => {
    return (
        <Card variant="outlined" sx={{ maxWidth: 345, maxWidth: 600, display: 'flex', justifyContent: 'center', margin: 1, p: 1 }}>
            <Stack alignItems="center" justifyContent="center">
                <Avatar
                    className="shine"
                    alt="OneProof"
                    src={IconOneProof}
                    sx={{ width: 62, height: 62, background: 'transparent', boxShadow: 2, margin: 1 }}
                />
                <Stack direction="row" spacing={1}>
                    <Typography sx={{ color: '#b62724', fontSize: '2.125rem', fontWeight: 700, fontFamily: 'Roboto' }}>
                        <NumberFormat
                            thousandsGroupStyle="thousand"
                            value={OneProofData?.amount}
                            prefix=""
                            decimalSeparator="."
                            displayType="text"
                            type="text"
                            thousandSeparator={true}
                            allowNegative={true}
                        />
                    </Typography>
                    <Typography variant="subtitle1" sx={{ color: '#b62724', fontFamily: 'Roboto', fontSize: '0.875rem', fontWeight: 500 }}>
                        {OneProofData?.ccy}
                    </Typography>
                </Stack>
                <Divider primary="Drafts" />
                <CardHeader
                    sx={{ p: 1 }}
                    avatar={
                        <Avatar sx={{ background: '#bcbec2', boxShadow: 1, color: 'gray' }} aria-label="recipe">
                            ?
                        </Avatar>
                    }
                    title={
                        <>
                            <Divider flexItem textAlign="left" component="div" role="presentation">
                                <Typography sx={{ fontSize: 12, fontFamily: 'boonhome-400' }}>From Account</Typography>
                            </Divider>
                            <Typography variant="subtitle1" sx={{ fontFamily: 'Roboto', fontSize: '0.875rem', fontWeight: 500 }}>
                                {OneProofData?.sourcename}
                            </Typography>
                        </>
                    }
                    subheader={
                        <Stack direction="row" spacing={1}>
                            <Typography sx={{ fontFamily: 'Roboto', fontSize: '0.875rem', fontWeight: 400 }}>
                                {OneProofData?.sourceaccount}
                            </Typography>
                            <Typography
                                sx={{ color: '#4686e6', fontFamily: 'Roboto', fontSize: '0.875rem', fontWeight: 400 }}
                            >{`${OneProofData?.sourceccy}`}</Typography>
                        </Stack>
                    }
                />
                <Divider>
                    <SwapVertIcon />
                </Divider>
                <CardHeader
                    sx={{ p: 1 }}
                    avatar={
                        <Avatar sx={{ background: '#bcbec2', boxShadow: 1, color: 'gray' }} aria-label="recipe">
                            ?
                        </Avatar>
                    }
                    title={
                        <>
                            <Divider flexItem textAlign="left" component="div" role="presentation">
                                <Typography sx={{ fontSize: 12, fontFamily: 'boonhome-400' }}>To Account</Typography>
                            </Divider>
                            <Typography variant="subtitle1" sx={{ fontFamily: 'Roboto', fontSize: '0.875rem', fontWeight: 500 }}>
                                {OneProofData?.destinationname}
                            </Typography>
                        </>
                    }
                    subheader={
                        <Stack direction="row" spacing={1}>
                            <Typography sx={{ fontFamily: 'Roboto', fontSize: '0.875rem', fontWeight: 400 }}>
                                {OneProofData?.destinationaccount}
                            </Typography>
                            <Typography
                                sx={{ color: '#4686e6', fontFamily: 'Roboto', fontSize: '0.875rem', fontWeight: 400 }}
                            >{`${OneProofData?.destinationccy}`}</Typography>
                        </Stack>
                    }
                />
                <Divider flexItem textAlign="left" component="div" />
                <Stack>
                    <Typography variant="caption" sx={{ fontFamily: 'Roboto', fontSize: '0.75rem', fontWeight: 400 }}>
                        Description
                    </Typography>
                    <Typography variant="body" sx={{ fontFamily: 'boonhome-400' }}>
                        {OneProofData?.description}
                    </Typography>
                </Stack>
                <Divider flexItem textAlign="left" component="div" />
                <CardContent>
                    <Grid container>
                        <Grid item xs align="left">
                            <Stack direction="row">
                                <ScheduleIcon sx={{ width: 42, height: 42 }} />
                                <Stack>
                                    <Typography variant="caption" sx={{ fontFamily: 'Roboto', fontSize: '0.75rem', fontWeight: 400 }}>
                                        Time
                                    </Typography>
                                    <Typography variant="body">{OneProofData?.txtime}</Typography>
                                </Stack>
                            </Stack>
                        </Grid>
                        <Divider orientation="vertical" flexItem />
                        <Grid item xs align="left">
                            <Stack direction="row">
                                <EventNoteIcon sx={{ width: 42, height: 42 }} />
                                <Stack>
                                    <Typography variant="caption" sx={{ fontFamily: 'Roboto', fontSize: '0.75rem', fontWeight: 400 }}>
                                        Reference
                                    </Typography>
                                    <Typography variant="body">{OneProofData?.fccref}</Typography>
                                    <Typography variant="caption" sx={{ fontFamily: 'Roboto', fontSize: '0.75rem', fontWeight: 400 }}>
                                        Ticket
                                    </Typography>
                                    <Typography variant="body">{OneProofData?.ticket}</Typography>
                                </Stack>
                            </Stack>
                        </Grid>
                    </Grid>
                </CardContent>
            </Stack>
        </Card>
    );
};

export default OneProofSlipCard;
